import React from 'react'
import { Link } from 'react-router-dom'
import { FaCashRegister, FaFileMedical } from 'react-icons/fa'
function Dashboard () {
  return (
    <>
      {/* @include('sweet::alert') */}

        <nav className='main-header navbar navbar-expand navbar-white navbar-light'>
          <ul className='navbar-nav'>
            <li className='nav-item'>
              <a className='nav-link' data-widget='pushmenu' href='#'>
                <i className='fas fa-bars'></i>
              </a>
            </li>
          </ul>
          <div className='title'>
            <h1>Finance & Admin Module</h1>
          </div>
          {/* <!-- end youtube test -->
    <!-- Right navbar links --> */}
          <ul className='navbar-nav ml-auto'></ul>
        </nav>

        <div className='content-wrapper'>
          <div className='content-header'>
            <div className='container-fluid'>
              <div className='row mb-2'>
                <div className='col-sm-12'>
                  <ol className='breadcrumb'>
                    <li className='breadcrumb-item active'>
                      Balance Sheet List
                    </li>
                  </ol>
                </div>
              </div>
            </div>
          </div>

          <section className='content'>
            <div className='container-fluid'>
              <div className='row'>
                <div className='col-12'>
                  <div className='card'>
                    <div className='card-header'>
                      <h1 className='card-title font-weight-bold px-3 py-3'>
                        Statement of Finiancial Position as at 30 September 2022
                      </h1>

                      {/* {{-- <button id="" class="btn btn-primary float-right" data-toggle="modal" data-target="#new_account" onclick="hide_proj()"> <i class="fa fa-plus"></i> Create Accounting</button> --}} */}
                      {/* {{-- <div class="modal fade" id="new_account" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true">
                    <div class="modal-dialog" role="document">
                        <div class="modal-content">
                        <div class="modal-header ok">
                            <h5 class="modal-title" id="exampleModalLabel">Add New Accounting</h5>
                            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                            </button>
                        </div>
                        <form action="{{route('store_accounting')}}" method="post">
                            @csrf
                        <div class="modal-body">
                            <div class="form-group">
                                <label for="name">Account Code</label>
                                <input type="text" class="form-control border border-info" name="acc_code" id="acc_code" placeholder="eg. 123456">
                            </div>
                            <div class="form-group">
                                <label for="name">Account Name</label>
                                <input type="text" class="form-control border-info" name="acc_name" id="acc_name" placeholder="eg. Revenue Account">
                            </div>
                            <div class="form-group">
                                <label for="name">Account Type</label>
                                <select class="custom-select border-info" name="account_type_id">
                                <option>Choose Account Type</option>
                                    @foreach($account_type as $acc_type)
                                    <option value="{{$acc_type->id}}">{{$acc_type->type_name}}</option>
                                   @endforeach
                                </select>
                            </div>
                            <div class="form-group">
                                <label for="name">Cost Center</label>
                                <select class="custom-select border-info" name="cost_center">
                                <option>Choose Cost Center Name</option>
                                    @foreach($cost_center as $cc)
                                    <option value="{{$cc->id}}">{{$cc->name}}</option>
                                    @endforeach
                                </select>
                            </div>
                            <div class="form-group">
                                <label for="name">Balance</label>
                                <input type="text" class="form-control border-info" name="balance">
                            </div>
                            <div class="form-group">
                                <label for="name">Currency</label>
                                <select class="custom-select border-info" name="currency">

                                <option>Choose Currency</option>

                                    @foreach($currency as $cc)
                                    <option value="{{$cc->id}}">{{$cc->name}}</option>
                                    @endforeach
                                </select>
                            </div>
                            <div class="form-group">
                                <label for="name">Projected Related</label>
                                <div class="row">
                                    <div class="col-md-6">
                                    <div class="form-check form-check-inline">
                                        <input class="form-check-input" type="radio" name="yes_no" id="yes" value="1" onclick="show_project()">
                                        <label class="form-check-label text-info" for="bank">Yes</label>
                                      </div>
                                    </div>
                                    <div class="col-md-6">
                                      <div class="form-check form-check-inline">

                                        <input class="form-check-input" type="radio" name="yes_no" id="no" value="2" onclick="hide_project()">
                                        <label class="form-check-label text-info" for="cash">No</label>
                                    </div>
                                    </div>
                                </div>
                            </div>
                            <div class="form-group" id="proj">
                                <label for="name">Project</label>
                                <select class="custom-select border-info" name="project_id">
                                <option value="0">Choose Project Name</option>
                                    @foreach($saleproject as $salepro)
                                    <option value="{{$salepro->id}}">{{$salepro->name}}</option>
                                    @endforeach
                                </select>
                            </div>
                        </div>
                        <div class="modal-footer">
                            <button type="button" class="btn btn-secondary" data-dismiss="modal">Close</button>
                            <button type="submit" class="btn btn-primary">Save</button>
                        </div>
                        </form>
                        </div>
                    </div>
                </div> --}} */}
                    </div>
                    <div class='card-body'>
                      <table id='example1' class='table'>
                        <thead class='text-center ok'>
                          <tr>
                            <th>No</th>
                            <th>Account Name</th>
                            <th>Exchange Rate</th>
                            <th>Amount(USD)</th>
                            <th>Total Amount(USD)</th>
                            <th>Amount(MMK)</th>
                            <th>Total Amount(MMK)</th>
                          </tr>
                        </thead>

                        <tbody class='text-center'>
                          <tr>
                            <td></td>
                            <td>
                              <u>Non Current Asset</u>
                            </td>
                            <td></td>
                            <td></td>
                            <td></td>
                            <td></td>
                            <td></td>
                          </tr>
                          <tr>
                            <td></td>
                            <td>Fixed Asset(Net Book Value)</td>
                            <td></td>
                            <td></td>
                            <td></td>
                            <td></td>
                            <td></td>
                          </tr>
                          {/* <?php $i=1;
                        $tot_amt = 0;
                    ?>
                    @foreach ($account as $acc) */}
                          <tr>
                            <td>1</td>
                            <td>fix_account_test</td>
                            <td></td>
                            <td></td>
                            <td></td>
                            <td>15000000</td>
                            <td></td>
                          </tr>
                          {/* <?php
                         $tot_amt += $acc->amount;
                    ?>

                    @endforeach */}
                          <tr>
                            <td></td>
                            <td></td>
                            <td></td>
                            <td></td>
                            <td></td>
                            <td></td>
                            <td></td>
                          </tr>

                          <tr>
                            <td></td>
                            <td>Intangible Asset</td>
                            <td></td>
                            <td></td>
                            <td></td>
                            <td>0</td>
                            <td></td>
                          </tr>

                          <tr>
                            <td></td>
                            <td></td>
                            <td></td>
                            <td></td>
                            <td></td>
                            <td></td>
                            <td>1540000</td>
                          </tr>

                          <tr>
                            <td></td>
                            <td>
                              <u>Current Asset</u>
                            </td>
                            <td></td>
                            <td></td>
                            <td></td>
                            <td></td>
                            <td></td>
                          </tr>

                          <tr>
                            <td></td>
                            <td>Cash in Hand</td>
                            <td></td>
                            <td></td>
                            <td></td>
                            <td>10964141</td>
                            <td></td>
                          </tr>
                          <tr>
                            <td></td>
                            <td>Bank Balance</td>
                            <td></td>
                            <td></td>
                            <td></td>
                            <td>-13582295</td>
                            <td></td>
                          </tr>
                          <tr>
                            <td></td>
                            <td>Account Receiable</td>
                            <td></td>
                            <td></td>
                            <td></td>
                            <td>100346000</td>
                            <td></td>
                          </tr>
                          <tr>
                            <td></td>
                            <td>Prepaid Expense</td>
                            <td></td>
                            <td></td>
                            <td></td>
                            <td>0</td>
                            <td></td>
                          </tr>
                          {/* <?php $tot_curr = $account1+$account2+$account3; ?> */}
                          <tr>
                            <td></td>
                            <td></td>
                            <td></td>
                            <td></td>
                            <td></td>
                            <td></td>
                            <td>15400000</td>
                          </tr>
                          {/* <?php $tot_ass = $tot_amt + $tot_curr; ?> */}
                          <tr>
                            <td></td>
                            <td>Total Asset</td>
                            <td></td>
                            <td></td>
                            <td></td>
                            <td></td>
                            <td>113127846</td>
                          </tr>
                          <tr>
                            <td></td>
                            <td>
                              <u>Equity</u>
                            </td>
                            <td></td>
                            <td></td>
                            <td></td>
                            <td></td>
                            <td></td>
                          </tr>
                          <tr>
                            <td></td>
                            <td>
                              <u>Capital</u>
                            </td>
                            <td></td>
                            <td></td>
                            <td></td>
                            <td></td>
                            <td></td>
                          </tr>
                          <tr>
                            <td></td>
                            <td>Retained Earning up to 30.9.2019</td>
                            <td></td>
                            <td></td>
                            <td></td>
                            <td>0</td>
                            <td></td>
                          </tr>
                          <tr>
                            <td></td>
                            <td>Retained Earning up to 30.9.2020</td>
                            <td></td>
                            <td></td>
                            <td></td>
                            <td>0</td>
                            <td></td>
                          </tr>
                          <tr>
                            <td></td>
                            <td>
                              <u>Writeoff Expense(Ajustment)</u>
                            </td>
                            <td></td>
                            <td></td>
                            <td></td>
                            <td></td>
                            <td></td>
                          </tr>
                          <tr>
                            <td></td>
                            <td>Project Additional Payable</td>
                            <td></td>
                            <td></td>
                            <td></td>
                            <td>0</td>
                            <td></td>
                          </tr>
                          {/* <?php
                      session_start();
                     $pro =  $_SESSION['favcolor'];
                    ?> */}
                          <tr>
                            <td></td>
                            <td>Profit for the year</td>
                            <td></td>
                            <td></td>
                            <td></td>
                            <td>1050139</td>
                            <td></td>
                          </tr>
                          <tr>
                            <td></td>
                            <td>Unrealized Exchange Gain/(Loss)</td>
                            <td></td>
                            <td></td>
                            <td></td>
                            <td>0</td>
                            <td></td>
                          </tr>
                          <tr>
                            <td></td>
                            <td>Dividend</td>
                            <td></td>
                            <td></td>
                            <td></td>
                            <td>0</td>
                            <td></td>
                          </tr>
                          <tr>
                            <td></td>
                            <td>Total Equity</td>
                            <td></td>
                            <td></td>
                            <td></td>
                            <td></td>
                            <td>1050139</td>
                          </tr>
                          <tr>
                            <td></td>
                            <td>
                              <u>Current Liabilities</u>
                            </td>
                            <td></td>
                            <td></td>
                            <td></td>
                            <td></td>
                            <td></td>
                          </tr>
                          <tr>
                            <td></td>
                            <td>Tender Payable</td>
                            <td></td>
                            <td></td>
                            <td></td>
                            <td>1200000</td>
                            <td></td>
                          </tr>
                          <tr>
                            <td></td>
                            <td>Kakahtoke Payable</td>
                            <td></td>
                            <td></td>
                            <td></td>
                            <td>0</td>
                            <td></td>
                          </tr>
                          <tr>
                            <td></td>
                            <td>Payable to Bank Loan</td>
                            <td></td>
                            <td></td>
                            <td></td>
                            <td>0</td>
                            <td></td>
                          </tr>
                          <tr>
                            <td></td>
                            <td>Other Payable</td>
                            <td></td>
                            <td></td>
                            <td></td>
                            <td>0</td>
                            <td></td>
                          </tr>
                          <tr>
                            <td></td>
                            <td></td>
                            <td></td>
                            <td></td>
                            <td></td>
                            <td></td>
                            <td>1200000</td>
                          </tr>
                          <tr>
                            <td></td>
                            <td>
                              <u>Long-term Liabilities</u>
                            </td>
                            <td></td>
                            <td></td>
                            <td></td>
                            <td></td>
                            <td></td>
                          </tr>
                          <tr>
                            <td></td>
                            <td>Loan</td>
                            <td></td>
                            <td></td>
                            <td></td>
                            <td>0</td>
                            <td></td>
                          </tr>
                          <tr>
                            <td></td>
                            <td>Total Liabilities</td>
                            <td></td>
                            <td></td>
                            <td></td>
                            <td></td>
                            <td>1200000</td>
                          </tr>
                          {/* <?php $tot_equ_lia = $pro + $account4 ; ?> */}
                          <tr>
                            <td></td>
                            <td>Total Equity & Liabilities</td>
                            <td></td>
                            <td></td>
                            <td></td>
                            <td></td>
                            <td>2250139</td>
                          </tr>
                        </tbody>
                      </table>
                      {/* <?php

              echo '<br /><a href="profit_loss_acc_list" class="float-left">Profit & Loss</a>
                          <a href="trial_balance" class="float-right">Trial Balance</a>
                           ';

                ?> */}
                      <a href='/profit_loss' class='float-left mt-3'>
                        Profit & Loss
                      </a>
                      <a href='/balance_sheet' class='float-right mt-3'>
                        Trial Balance
                      </a>
                    </div>
                  </div>
                </div>
              </div>
            </div>{' '}
            {/*<!-- /.container-fluid --> */}
          </section>
        </div>

      <script src="{{asset('plugins/jquery/jquery.min.js')}}"></script>
      <script src="{{asset('plugins/jquery-ui/jquery-ui.min.js')}}"></script>

      {/* <!-- Resolve conflict in jQuery UI tooltip with Bootstrap tooltip -->*/}
      <script>$.widget.bridge('uibutton', $.ui.button)</script>
      <script src="{{asset('plugins/bootstrap/js/bootstrap.bundle.min.js')}}"></script>
      <script src="{{asset('plugins/chart.js/Chart.min.js')}}"></script>
      <script src="{{asset('plugins/sparklines/sparkline.js')}}"></script>
      <script src="{{asset('plugins/jquery-knob/jquery.knob.min.js')}}"></script>
      <script src="{{asset('plugins/moment/moment.min.js')}}"></script>
      <script src="{{asset('plugins/daterangepicker/daterangepicker.js')}}"></script>

      <script src="{{asset('plugins/tempusdominus-bootstrap-4/js/tempusdominus-bootstrap-4.min.js')}}"></script>
      <script src="{{asset('plugins/summernote/summernote-bs4.min.js')}}"></script>
      <script src="{{asset('plugins/overlayScrollbars/js/jquery.overlayScrollbars.min.js')}}"></script>
      <script src="{{asset('dist/js/adminlte.js')}}"></script>

      <script src="{{asset('dist/js/demo.js')}}"></script>

      <script src="{{asset('plugins/datatables/jquery.dataTables.js')}}"></script>
      <script src="{{asset('plugins/datatables/dataTables.bootstrap')}}"></script>
      <script src="{{asset('plugins/datatables-bs4/js/dataTables.bootstrap4.js')}}"></script>
      <script src="{{asset('plugins/bootstrap-material-datetimepicker/js/bootstrap-material-datetimepicker.js')}}"></script>
    </>
  )
}
export default Dashboard
